import { useEffect, useMemo, useState } from 'react'
import { OwnershipReasonEnum } from '../models/enum/ownership-reason.enum';
import { LoanTypeEnum } from '../models/enum/loan-type.enum';
import { SchemeTypeEnum } from '../models/enum/scheme-type.enum';
import { HousingSchemeChecking, checkIsFlatResale } from '../utils/form-helper';
import { StructureStatusEnum } from '../models/enum/structure-status.enum';
import { ApplicationStep1 } from '../models/classes/ApplicationStep1.class';
import { ApplicationStep2 } from '../models/classes/ApplicationStep2.class';
import { ApplicationStart } from '../models/classes/ApplicationStart.class';
import { ApplicationStep3 } from '../models/classes/ApplicationStep3.class';
import { SolicitorTypeEnum } from '../models/enum/solicitor-type.enum';
import { ResidentialStatusEnum } from '../models/enum/residential-status.enum';

function useCheckRemission(applicationStartFormData:ApplicationStart, applicationStep1FormData:ApplicationStep1, applicationStep2FormData:ApplicationStep2, applicationStep3FormData:ApplicationStep3) {
  
  const [newLoanType, setNewLoanType] = useState<LoanTypeEnum | undefined>(applicationStep2FormData.new_loan_type);
  const [schemeType, setSchemeType] = useState<string>("");

  const isFlatResale = useMemo(()=>{
    return checkIsFlatResale(applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code!); 
  },[applicationStartFormData.selected_hdb_property?.financing_info.sales_type_code]);


  const isOutrightTransfer = useMemo(()=>{
    const hasRetaining = applicationStep1FormData.household.incoming_owners.some( e=> e.structure_status === StructureStatusEnum.retaining );
    return !hasRetaining;
  },[applicationStep1FormData.household.incoming_owners])


  const isRemission = useMemo(()=>{
    const fullSPRHouseHold = applicationStep1FormData.household.incoming_owners.every(e=>e.myinfo.residential_status === ResidentialStatusEnum.pr);
    
    const reasonCondition = (applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.divorce || applicationStep1FormData.reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner); 
    const { is_eligible, scheme_type } = HousingSchemeChecking(applicationStep1FormData);

    const hdbConveyancing = (applicationStep3FormData.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor && applicationStep3FormData.proposed.hdb_solicitor.represented_same_solicitor === false && applicationStep3FormData.proposed.conveyancing_private_solicitor.is_confirm === true);
    const privateConveyancing = applicationStep3FormData.proposed_solicitor_type === SolicitorTypeEnum.private_solicitor;
    const directPrivateConveyancing = applicationStep3FormData.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor;

    const isPrivateConveyancing = hdbConveyancing || privateConveyancing || directPrivateConveyancing;

    const condition1 = isFlatResale && newLoanType === LoanTypeEnum.hdb_loan; //COMPLETED
    const condition2 = isPrivateConveyancing; //COMPLETED
    const condition3 = is_eligible && scheme_type === SchemeTypeEnum.joint_single_schema; //COMPLETED
    const condition4 = isOutrightTransfer || (condition3); //COMPLETED


    const absd_condition1 = fullSPRHouseHold;
    const absd_condition2 = (applicationStep3FormData.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor && applicationStep3FormData.proposed.hdb_solicitor.represented_same_solicitor) || applicationStep3FormData.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor;

    if(absd_condition1 && absd_condition2){
      console.log("1");

      return false;
    }

    if(condition1){
      console.log("2");
      return true;
    }
    else{
      if(isOutrightTransfer){
        return false;
      }

      if(condition2){
        console.log("3");
        return true; 
      }
      else{
        if(reasonCondition){
          if(condition3){
            console.log("4");
            return false;
          }else{
            console.log("5");
            return true;
          }
        }
        else{
          if(condition4){
            console.log("6", isOutrightTransfer, condition3);
            return false;
          }else{
            console.log("7");
            return true;
          }
        }
      }
    }
  },[applicationStep1FormData, newLoanType, applicationStep3FormData.proposed.conveyancing_private_solicitor.is_confirm, applicationStep3FormData.proposed.hdb_solicitor.represented_same_solicitor, applicationStep3FormData.proposed_solicitor_type, isFlatResale, isOutrightTransfer])

  useEffect(() => {
    const { scheme_type } = HousingSchemeChecking(applicationStep1FormData);
    setSchemeType(scheme_type);
  }, [applicationStep1FormData])


  return { isRemission: isRemission, displayValuation: !isRemission, setNewLoanType: setNewLoanType, schemeType }
}

export default useCheckRemission